"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import "../styles/Relatorio.css"
import { FaFileDownload, FaFileAlt } from "react-icons/fa"

const Relatorio = () => {
  const [eventos, setEventos] = useState([])
  const [categorias, setCategorias] = useState([])
  const [eventoSelecionado, setEventoSelecionado] = useState("")
  const [categoriaSelecionada, setCategoriaSelecionada] = useState("")
  const [loading, setLoading] = useState(false)

  // 🔄 Carregar eventos do dono com autenticação
  useEffect(() => {
    const fetchEventos = async () => {
      try {
        setLoading(true)
        const response = await axios.get("https://api.ticketdovaqueiro.com/api/events/dono", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        setEventos(response.data)
        setLoading(false)
      } catch (error) {
        console.error("Erro ao buscar eventos:", error)
        setLoading(false)
      }
    }
    fetchEventos()
  }, [])

  // 🔄 Carregar categorias com base no evento
  useEffect(() => {
    const fetchCategorias = async () => {
      if (eventoSelecionado) {
        try {
          setLoading(true)
          const response = await axios.get(
            `https://api.ticketdovaqueiro.com/api/events/${eventoSelecionado}/categorias`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            },
          )
          setCategorias(response.data)
          setLoading(false)
        } catch (error) {
          console.error("Erro ao buscar categorias:", error)
          setLoading(false)
        }
      }
    }
    fetchCategorias()
  }, [eventoSelecionado])

  // 📥 Baixar relatório
  const handleBaixarRelatorio = () => {
    if (!eventoSelecionado || !categoriaSelecionada) {
      alert("Selecione o evento e a categoria!")
      return
    }
    window.open(
      `https://api.ticketdovaqueiro.com/api/relatorios/gerar-pdf?eventoId=${eventoSelecionado}&categoria=${categoriaSelecionada}`,
      "_blank",
    )
  }

  const handleBaixarRelatorioJuizLocutor = () => {
    if (!eventoSelecionado || !categoriaSelecionada) {
      alert("Selecione o evento e a categoria!")
      return
    }
    window.open(
      `https://api.ticketdovaqueiro.com/api/relatorios/gerar-pdf-juiz-locutor?eventoId=${eventoSelecionado}&categoria=${categoriaSelecionada}`,
      "_blank",
    )
  }

  return (
    <div className="relatorio-container">
      <h2 className="relatorio-titulo">📄 Relatório de Pedidos</h2>

      <div className="form-group">
        <label>Evento</label>
        <select value={eventoSelecionado} onChange={(e) => setEventoSelecionado(e.target.value)} disabled={loading}>
          <option value="">Selecione um evento</option>
          {eventos.map((evento) => (
            <option key={evento._id} value={evento._id}>
              {evento.nome}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Categoria</label>
        <select
          value={categoriaSelecionada}
          onChange={(e) => setCategoriaSelecionada(e.target.value)}
          disabled={!categorias.length || loading}
        >
          <option value="">Selecione uma categoria</option>
          {categorias.map((categoria) => (
            <option key={categoria._id} value={categoria.nome}>
              {categoria.nome}
            </option>
          ))}
        </select>
      </div>

      <button
        className="botao-relatorio"
        onClick={handleBaixarRelatorio}
        disabled={!eventoSelecionado || !categoriaSelecionada || loading}
      >
        <FaFileDownload size={18} />
        Baixar Relatório PDF
      </button>

      <button
        className="botao-locutorjuiz"
        onClick={handleBaixarRelatorioJuizLocutor}
        disabled={!eventoSelecionado || !categoriaSelecionada || loading}
      >
        <FaFileAlt size={18} />
        Gerar PDF Juiz/Locutor
      </button>

      <button
        className="botao-locutorjuiz"
        onClick={() => {
          if (!eventoSelecionado) return alert("Selecione o evento!");
          window.open(
            `https://api.ticketdovaqueiro.com/api/relatorios/gerar-relatorio-geral?eventoId=${eventoSelecionado}`,
            "_blank"
          );
        }}
        disabled={!eventoSelecionado || loading}
      >
        <FaFileAlt size={18} />
        Gerar Relatório Financeiro (PDF)
      </button>

    </div>
  )
}

export default Relatorio

